import React, {useEffect} from 'react';
import {Text} from '@gravity-ui/uikit';
import {ActionModal, ErrorModal, useErrorHandler} from '../../../../shared';
import {useCategoryGroups} from '../../../../entities';

interface DeleteCategoryGroupModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  categoryGroupId: string | null;
  onSuccess?: () => void;
}

export const DeleteCategoryGroupModal = ({
  open,
  setOpen,
  categoryGroupId,
  onSuccess,
}: DeleteCategoryGroupModalProps) => {
  const {deleteCategoryGroupMutation} = useCategoryGroups();

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Удаление группы категорий',
    title: 'Ошибка при удалении группы категорий',
  });

  useEffect(() => {
    if (deleteCategoryGroupMutation.error) {
      handleError(deleteCategoryGroupMutation.error as unknown as ApiError);
    }
  }, [deleteCategoryGroupMutation.error, handleError]);

  const handleSubmit = () => {
    if (!categoryGroupId) return;
    deleteCategoryGroupMutation.mutate(categoryGroupId, {
      onSuccess: () => {
        setOpen(false);
        onSuccess?.();
      },
    });
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleSubmit}
        isLoading={deleteCategoryGroupMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Удаление группы'}
        textButtonApply={'Удалить'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите удалить эту группу? Обратите внимание, что это действие безвозвратное
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
